import React from 'react';
import LegalPageLayout from './LegalPageLayout';

const FAQ = [
  {
    question: 'The game is not running smoothly on my device.',
    answer:
      'Please make sure you are using the latest version of the game, close other apps running in the background, wait for your device to cool down if it is hot, and restart your device before trying again.',
  },
  {
    question: 'I lost my progress or a purchased item.',
    answer:
      'Please email support with as much detail as possible, including your device, app version, and any purchase information if relevant.',
  },
  {
    question: 'The game crashed or froze.',
    answer:
      'Please restart the game and contact support with your device model, operating system version, app version, and a description of what happened.',
  },
  {
    question: 'I found a bug or visual issue.',
    answer:
      'Please send us a description of the issue and, if possible, screenshots or a screen recording.',
  },
  {
    question: 'How do I request deletion of my data?',
    answer:
      'Please visit the Data Deletion page or email support with the subject line "AutoRaja Data Deletion Request."',
  },
];

const AutoRajaSupport = ({ navigateToPath }) => (
  <LegalPageLayout
    route="autoraja-support"
    kicker="Support"
    title="AutoRaja Support"
    navigateToPath={navigateToPath}
  >
    <p className="legal-lead">
      Need help with AutoRaja? If you&apos;re having trouble with gameplay, ads,
      purchases, performance, or anything else, please contact us and we&apos;ll
      do our best to help.
    </p>

    <div className="info-panel legal-contact-panel">
      <p className="contact-name">Support email</p>
      <p className="legal-contact-email">
        <a href="mailto:contact@mixout.in?subject=AutoRaja%20Support">
          contact@mixout.in
        </a>
      </p>
      <p className="muted-note">
        We aim to respond to support requests within a reasonable time.
      </p>
    </div>

    <h2 id="faq">Frequently Asked Questions</h2>
    <div className="faq-list">
      {FAQ.map((item, index) => (
        <details key={item.question} className="faq-item" open={index === 0}>
          <summary>{item.question}</summary>
          <p>{item.answer}</p>
        </details>
      ))}
    </div>

    <h2 id="troubleshooting">Basic Troubleshooting</h2>
    <ul className="legal-list">
      <li>Restart the game.</li>
      <li>Wait for your device to cool down if it feels hot.</li>
      <li>Update to the latest version of AutoRaja.</li>
      <li>Restart your device.</li>
      <li>Ensure you have a stable internet connection for ad-related features.</li>
    </ul>

    <h2 id="what-to-include">What To Include When You Contact Us</h2>
    <p>To help us resolve your issue quickly, please include:</p>
    <ul className="legal-list">
      <li>Device model (for example, iPhone 15 or Pixel 8).</li>
      <li>Operating system version.</li>
      <li>AutoRaja app version.</li>
      <li>A clear description of the issue and when it happens.</li>
      <li>Screenshots or a screen recording if possible.</li>
      <li>Any relevant purchase details.</li>
    </ul>

    <h2 id="response-time">Response Time</h2>
    <p>
      We aim to respond to support requests within a reasonable time. Complex
      issues may take longer while we investigate.
    </p>

    <h2 id="related">Related Pages</h2>
    <ul className="legal-list">
      <li>
        <a
          href="/autoraja/privacy"
          onClick={(event) => {
            event.preventDefault();
            navigateToPath('/autoraja/privacy');
          }}
        >
          Privacy Policy
        </a>
      </li>
      <li>
        <a
          href="/autoraja/delete-data"
          onClick={(event) => {
            event.preventDefault();
            navigateToPath('/autoraja/delete-data');
          }}
        >
          Data Deletion Requests
        </a>
      </li>
    </ul>
  </LegalPageLayout>
);

export default AutoRajaSupport;
